(() => {
  function mountForm(form) {
    if (form.dataset.mounted) return;
    form.dataset.mounted = 'true';
    const quantities = [...form.querySelectorAll('[data-origin-quantity]')];
    const wallets = form.querySelector('[data-origin-wallets]');
    const unsaved = form.querySelector('[data-origin-unsaved]');
    const limit = form.querySelector('[data-origin-limit]');
    const checkout = form.querySelector('[name="checkout"]');
    const savedQuantities = quantities.map((input) => input.value);
    const controls = quantities.map((input) => ({
      input,
      decrease: input.closest('.origin-cart-quantity').querySelector('[data-origin-quantity-step="-1"]'),
      increase: input.closest('.origin-cart-quantity').querySelector('[data-origin-quantity-step="1"]')
    }));

    function updateState() {
      const dirty = quantities.some((input, index) => input.value !== savedQuantities[index]);
      const eligibleTotal = quantities.reduce((total, input) => {
        if (input.dataset.originTag !== 'true') return total;
        return total + (input.valueAsNumber || 0);
      }, 0);
      const invalidInput = quantities.some((input) => !input.validity.valid);
      const overLimit = eligibleTotal > 5;
      controls.forEach(({ input, decrease, increase }) => {
        decrease.hidden = false;
        increase.hidden = false;
        decrease.disabled = !Number.isFinite(input.valueAsNumber) || input.valueAsNumber <= 1;
        increase.disabled = input.dataset.originTag === 'true' && eligibleTotal >= 5;
      });
      unsaved.hidden = !dirty;
      limit.hidden = !overLimit;
      if (wallets) wallets.hidden = dirty || overLimit || invalidInput;
      checkout.disabled = form.dataset.originInvalid === 'true' || overLimit || invalidInput || dirty;
      return !overLimit && !invalidInput;
    }

    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-origin-quantity-step]');
      if (!button || button.disabled) return;
      const input = button.closest('.origin-cart-quantity').querySelector('[data-origin-quantity]');
      input.stepUp(Number(button.dataset.originQuantityStep));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    form.addEventListener('input', updateState);
    form.addEventListener('submit', (event) => {
      const validQuantity = updateState();
      if (!validQuantity || (event.submitter?.name === 'checkout' && checkout.disabled)) {
        event.preventDefault();
        if (!form.reportValidity()) return;
        limit.focus();
      }
    });
    updateState();
  }
  function mount(root) { root.querySelectorAll('[data-origin-cart]').forEach(mountForm); }
  globalThis.OriginCartForms = { mount };
  mount(document);
})();
